<template>
  <vuex-table :fields="fields" table_store="pbx/phone-lists/table">
    <template slot="name" slot-scope="{ item }">
      <router-link :to="{ name: 'pbx.phone-list.edit', params: { id: item.id } }">
        {{ item.name }}
      </router-link>
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-control type="trash" @click="remove_item(item)" />
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions } from 'vuex';
  import { PhoneListModalService } from '@pbx/modals/PhoneListModalService';

  export default {
    components: {},

    data: () => ({
      edit_id: null
    }),

    computed: {
      fields: function() {
        return [
          { 
            key: 'name',
            label: this.$t('shared.component.table.field.name'), 
            sortable: true 
          },
          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true,
            class: 'text-center'
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center'
          }
        ];
      }
    },

    methods: {
      ...mapActions('pbx/phone-lists/table', ['getAsyncData']),

      remove_item: function(item) {
        PhoneListModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>
